<template>
  <b-row v-if="options && options.length" class="pr-3">
    <b-col
      v-for="(option, index) in options"
      :lg="lg"
      :md="md"
      :sm="sm"
      class="mb-3 pr-0"
      :key="index"
    >
      <b-button
        @click="onToggle(option[valueField])"
        :variant="
          value && value.includes(option[valueField])
            ? activeVariant
            : defaultVariant
        "
        size="sm"
        block
        class="p-2 h-100 text-left"
      >
        <i :class="`far fa-${option[iconField] || ''} font-2xl`" />
        <span
          class="pl-3 text-uppercase d-inline-block position-relative"
          style="top: -5px"
        >
          {{ option[textField] }}
        </span>
      </b-button>
    </b-col>
    <b-col 
      class="mb-3 pr-0"
      :lg="lg"
      :md="md"
      :sm="sm"
    >
      <b-button class="p2 h-100" block size="sm" :variant="'success'" @click="handleAddNew" v-if="add_contact">
        <i class="far fa-plus font-2xl" /> 
        <span 
          class="pl-3 text-uppercase d-inline-block position-relative"
          style="top: -5px"
        >
          Add Contact
        </span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "CustomFormCheckboxGroup",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    textField: {
      type: String,
      default: "text",
    },
    valueField: {
      type: String,
      default: "value",
    },
    iconField: {
      type: String,
      default: "icon",
    },
    state: {
      type: Boolean,
      default: false,
    },
    lg: {
      type: Number,
      default: 3,
    },
    md: {
      type: Number,
      default: 4,
    },
    sm: {
      type: Number,
      default: 5,
    },
    add_contact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeVariant: "primary",
      defaultVariant: "dark",
    };
  },
  methods: {
    onToggle(v) {
      const selected = this.value.find((item) => item === v)
        ? this.value.filter((item) => item !== v)
        : [...this.value, v];

      this.$emit("input", selected);
      this.$emit("change", selected);
    },
    handleAddNew() {
      this.$emit('addnew');
    }
  },
};
</script>
